import { render, staticRenderFns } from "./IdentityCertification.vue?vue&type=template&id=561e1634&scoped=true"
import script from "./IdentityCertification.vue?vue&type=script&lang=js"
export * from "./IdentityCertification.vue?vue&type=script&lang=js"
import style0 from "./IdentityCertification.vue?vue&type=style&index=0&id=561e1634&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561e1634",
  null
  
)

export default component.exports